exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rosteringMethodModal .rosteringSection{width:60%;margin-left:20%}.rosteringMethodModal .rosteringSection .inputContainer{display:flex;flex-direction:row;margin-bottom:1em}.rosteringMethodModal .rosteringSection .inputContainer .inputLabel{width:30%;font-weight:700;align-self:center}.rosteringMethodModal .rosteringSection .inputContainer .Select,.rosteringMethodModal .rosteringSection .inputContainer input{width:70%;margin:0}.rosteringMethodModal .rosteringSection .btnContainer{width:100%;text-align:center;padding:.5em 0}.rosteringMethodModal .rosteringSection .btnContainer button{padding:.3em 2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster/rostering_method_modal.scss
// module id = 866
// module chunks = 0